import Util from '../util.js';
import { getTempInfo, getStorage } from '../common.js';
const serviceReportList = (data) => {
	return {
		type: 'SERVICE_REPORTLIST',
		data
	}
}

const serviceReporDetail = (data) => {
	return {
		type: 'SERVICE_REPORTDETAIL',
		data
	}
}

export const serviceReporListDel = (data) => {
	return {
		type: 'LIST_DEL',
		data
	}
}

export const serviceReporDetailDel=(data)=>{
	return {
		type: 'DEL',
		data
	}
}
export const getServiceReportList = (params) => {
 // params.superFundCode='SF1009'
	return (dispatch, getState) => {
		const successCallback = (suc) => {
			console.log('=======', suc);
			if (suc.code == '0000') {
				const result = {}
				suc.content.data.forEach((item, index) => {
					if (item.monthReportToPortal) item.type = 2;
					else item.type = item.detailType
					if (result[item.newsTime]) {
						result[item.newsTime].push(item)
					} else {
						result[item.newsTime] = [item]
					}


				});
				console.log('----result----', result)
				//Object.entries(result).map((item)=>{console.log('----',item)})
				suc.content.processData = result
				console.log('---suc.content.data ---',suc.content )
				dispatch(serviceReportList(suc.content));
			} else {
				console.log('非正确数据！');
			}
		};
		const errorCallback = (err) => {
			console.log('请求失败', err);
		};
		Util.get(Util.url+'/api/v1/superFund/SuperFundReport/getRecentNewsReportList', params, successCallback, errorCallback);
	}
}

export const getServiceReportListHasQuarterly =  (params) => {
 
	return async(dispatch, getState) => {
		const successCallback = (suc) => {
			console.log('=======', suc);
			if (suc.code == '0000') {
				const result = {}
				suc.content.data.forEach((item, index) => {
				
					if (item.monthReportToPortal) item.type = 2;
					else item.type = item.detailType
					if (result[item.newsTime]) {
						result[item.newsTime].push(item)
					} else {
						result[item.newsTime] = [item]
					}


				});
				console.log('----result----', result)
				//Object.entries(result).map((item)=>{console.log('----',item)})
				suc.content.processData = result
				console.log('---suc.content.data ---',suc.content )
				dispatch(serviceReportList(suc.content));
			} else {
				console.log('非正确数据！');
			}
		};
		const errorCallback = (err) => {
			console.log('请求失败', err);
			// errcallback(Util.errorTxt);
			// dispatch(webViewHtmlString(''));
		};
		let token=await getTempInfo( 'shortToken' );
		params.token=token;
		//params.token='eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NTA2MTEyMTUsInN1YiI6IjIwMDAwMDc3MDM3IiwidXNlcklkIjoiMTY3NzAiLCJjZXJUeXBlIjoiMCIsImNlck5vIjoiMTEwMTAxMTk4NjA4MDgxMDM0IiwibmFtZSI6IuixhuixhjTlj7ciLCJ0aW1lc3RhcCI6MTY1MDYxMTIxNTg2N30.U4vX2UYD7QHVwRZEPVLx7d3bRagLiLUYd-qC8nXM6Qo'
		if(!params.token )return alert('请先登陆！')
		Util.get(Util.url+'/api/v1/superFund/SuperFundReport/getSuperFundReportList', params, successCallback, errorCallback)
	}
}

export const getServiceReportDetail = (params) => {
	return (dispatch, getState) => {
		const successCallback = (suc) => {
			console.log('=======', suc);
			if (suc.code == '0000') {
				if (suc.content.monthReportToPortal) suc.content.type = 2;
				suc.content.type = suc.content.detailType
				dispatch(serviceReporDetail(suc.content));
			} else {
				console.log('非正确数据！');
			}
		};
		const errorCallback = (err) => {
			console.log('请求失败', err);
			// errcallback(Util.errorTxt);
			// dispatch(webViewHtmlString(''));
		};
		Util.get(Util.url+'/api/v1/superFund/SuperFundReport/getRecentNewsReportDetail', params, successCallback, errorCallback);
	}
}


// WEBPACK FOOTER //
// ./src/action/ServiceReportAction.js